import { gql } from '@common/hooks';

const UpdateOrganizationProfileMutation = gql`
  mutation updateOrganizationProfileMutation(
    $organizationProfileId: ID!
    $input: UpdateOrganizationProfileInput!
  ) {
    updateOrganizationProfile(
      organizationProfileId: $organizationProfileId
      input: $input
    ) {
      organizationProfile {
        id
        employeeId
        estimatedConversionDate
        conversionDate
        contractHoursRemaining
        estimatedArrivalDate
        arrivedAtDate
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;

const UpdateArrivalDateMutation = gql`
  mutation updateArrivalDateMutation(
    $organizationProfileId: String!
    $estimatedArrivalDate: ISO8601Date
    $arrivedAtDate: ISO8601Date
  ) {
    updateArrivalDates(
      organizationProfileId: $organizationProfileId
      estimatedArrivalDate: $estimatedArrivalDate
      arrivedAtDate: $arrivedAtDate
    ) {
      organizationProfile {
        id
        estimatedArrivalDate
        arrivedAtDate
        contractHoursRemaining
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;

export { UpdateOrganizationProfileMutation, UpdateArrivalDateMutation };
